module.exports = __webpack_public_path__ + "img/gb-wls.db13343f.svg";